export const FORM_URL = 'https://go.lfg.inc/LFGCoreLaunchpad';
export const BUILD_WITH_US_URL = process.env.NEXT_PUBLIC_BUILD_WITH_US_URL || 'https://launch.lfg.inc';
export const ORBIT_URL = (process.env.NEXT_PUBLIC_ORBIT_URL as string) || 'https://orbit.lfg.inc';
export const ORBIT_CALENDAR_URL =
  (process.env.NEXT_PUBLIC_ORBIT_CALENDAR_URL as string) ||
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ3Q91vIs4TgL4PC4y0S5NYS8ORWQrnDMR4Mf2i2FO4seRAIcN28kwxVRJZSxrFTWqR5WcUckUe5?gv=true';
export const GA_ID = process.env.NEXT_PUBLIC_GA_ID as string;
